import React from 'react'
import { Link } from 'react-router'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import { history } from 'src/core/router'
import localstorage from 'src/helper/localstorage'

export default class extends React.Component {
  constructor(props) {
    super(props)
  }

  state = {
    uid: 0,
    accesstoken: '',
    lang: {},
    language: 'en'
  }

  async componentWillMount() {
    await setUidToken(this.props.location.query)
    setDocumentTitle(`Privacy Policy`)
    let { uid, accesstoken } = localstorage.get('userInfo')
    this.setState({
      uid: uid,
      accesstoken: accesstoken
    })
    
  }

  componentDidMount() {
  }

  jump = () => {
    history.push(`/activity/lottery?uid=${this.state.uid}&accesstoken=${this.state.accesstoken}`)
  }

  jumpChild = () => {
    history.push(`/app/child_safety_policy?uid=${this.state.uid}&accesstoken=${this.state.accesstoken}`)
  }

  render() {
    return (
      <div className="policy">
        <h1>Privacy Policy</h1>

        Last Updated: 2025/07/21<br/>
Effective Date: 2025/07/21<br/>
At Yayya, we recognize the importance of your privacy and are committed to providing you with a secure and private user experience.<br/>
Ensuring the security and protection of user data is our top priority. This Privacy Policy outlines the data we collect when you access and use our products and services, and how it is processed.<br/>
Please read and fully understand this policy before using or continuing to use our products and services. Follow the instructions where necessary to make informed choices.<br/>
If you do not agree with this policy, it may result in our products or services not functioning properly or failing to meet expectations.<br/>
You should immediately stop accessing or using our products and services.<br/>
Your continued use of our products and services indicates that you fully understand and agree to the contents of the Yayya Privacy Policy.<br/>

1. About Us<br/>
This full policy (including updated versions) sets out the basis on which we process any personal data collected from you or provided by you.<br/>
If you have any questions about how we use your personal data, please contact us at xxxx.<br/>
This Privacy Policy helps you understand the following:<br/>
1. How we collect and use your personal information;<br/>
2. How we store and protect your personal information;<br/>
3. How we share, transfer, and disclose your personal information;<br/>
4. How to delete your account;<br/>
5. CSAE commitments and related policies;<br/>
6. How to contact us.<br/>

1. How We Collect and Use Your Personal Information<br/>
We collect and use your personal information based on the principles of lawfulness, legitimacy, and necessity.<br/>
We collect data you voluntarily provide while using our services or data generated during your use of our products and/or services, and use it for the purposes specified in this policy.<br/>
If we need to use your personal data for purposes not covered in this policy or reuse collected information for a new purpose, we will inform you in a reasonable manner and obtain your consent again before use.<br/>
Additionally, we will keep the access frequency within a reasonable scope.<br/>

1.1. Summary of Device Permission Usage<br/>
During service delivery, we may request access to certain device permissions. You can disable some or all of them in your device settings.<br/>
Permission behavior and disabling may vary between devices. The device permissions we may request include:<br/>

<table border="1">
  <tr style={{textAlign: 'center',backgroundColor: '#f0f0f0'}}>
    <td>Device Permission</td>
    <td>Service Function</td>
    <td>Scenario Description</td>
    <td>Can Be Disabled</td>
  </tr>
  <tr>
    <td>Network Services</td>
    <td>Core service functionality</td>
    <td>Read and update app content</td>
    <td>Yes. Disabling this will prevent real-time updates and affect app usability.</td>
  </tr>
  <tr>
    <td>Media File Storage</td>
    <td>App stability</td>
    <td>Log recording and cache storage</td>
    <td>Yes. Disabling only affects the corresponding feature, and not other app functions.</td>
  </tr>
  <tr>
    <td>Microphone</td>
    <td>Core service functionality</td>
    <td>Voice communication</td>
    <td>Yes. Disabling only affects the corresponding feature, and not other app functions.</td>
  </tr>
</table>

2. Registration and Login<br/>
2.1 When you register or log in using your mobile number, we collect your [mobile number and carrier information] to provide a convenient login experience.<br/>
2.2 You may choose to provide or update your information as needed. Not providing certain optional data will not affect your use of the app and related services (excluding username, which is mandatory during registration).<br/>
2.3 Upon successful registration, we will display your personal information in the app.<br/>
When using platform services, we automatically collect data including your Open ID, IP address, device identifier, device series ID, Android ID, XID (generated based on existing device info, model, manufacturer, Android ID, and time zone settings), registration time, login time, and your usage records, such as operation dates and timestamps.<br/>

2. How We Store and Protect Your Personal Information<br/>
We strictly comply with the data protection laws of your country, and ensure that data recipients have sufficient capability to safeguard your personal information.<br/>
Retention period:<br/>
We promise to retain your personal information only for as long as is reasonably necessary and legally required.<br/>
After that, we will delete your personal information or anonymize it.<br/>
(Anonymization means processing data so that the individual cannot be identified and the data cannot be restored. Anonymized data is no longer considered personal information.)<br/>
If we cease operations, we will promptly stop collecting your personal data, notify you through services or announcements, and delete or anonymize all personal data we hold.<br/>

3. How We Share, Transfer, and Disclose Your Personal Information<br/>
We do not share your personal information with any company, organization, or individual except under one or more of the following circumstances:<br/>
(1) We have obtained your prior consent;<br/>
(2) You have personally requested it;<br/>
(3) Cooperation with third-party SDK providers:<br/>
When using features provided by third parties in Yayya, we may integrate third-party Software Development Kits (SDKs) to enable such features.<br/>
We require SDK providers to comply with our cooperation agreements, but they may still collect personal data.<br/>
The collection and handling of your information by these providers is governed by their own privacy policies, not this one.<br/>
To maximize your data safety, we recommend reviewing each third-party SDK's privacy policy before use.<br/>
If you identify a risk with an SDK or similar app, please stop using it and contact us immediately.<br/>

Details on third-party SDKs and their data collection:<br/>
1. IM<br/>
- SDK: Instant Messaging IM<br/>
- Provider: Easemob<br/>
- Purpose: Private messaging<br/>
- Collected Information: User avatar, username, private messages<br/>
- Privacy Policy: https://www.easemob.com/protocol<br/>

2. Storage<br/>
- SDK: AWS<br/>
- Provider: Amazon<br/>
- Purpose: File storage and image recognition<br/>
- Privacy Policy: https://aws.amazon.com/privacy/<br/>

3. Audio<br/>
- SDK: Agora<br/>
- Provider: Agora<br/>
- Purpose: Voice communication<br/>
- Collected Information: Network type, user’s local IP address, WiFi and cellular signal status, operating system, device model, CPU, memory, battery level, audio stream data, Bluetooth, network latency, packet loss rate, bitrate, resolution, audio bitrate, sampling rate<br/>
- Privacy Policy: https://www.agora.io/cn/privacy-policy<br/>

4. How to Delete Your Account<br/>
You can delete your account in the app by going to Settings > Account > Linked Accounts > Delete Account.<br/>
After deletion, your personal information will be removed from Yayya, except for data we are legally required to retain (e.g. by government or law).<br/>

5. CSAE Commitments and Related Policies<br/>
We are committed to preventing abuse and exploitation of children and strictly follow relevant laws and standards.<br/>
You can view our policy details at the following link: [Link to the statement page or relevant resource]<br/>

6. Contact Us<br/>
If you have any questions or suggestions about this Privacy Policy, please contact us via:<br/>
steven1082025@outlook.com<br/>

Statement: We may update this Privacy Policy based on legal or feature changes.<br/>
Any changes will be promptly published on this page. Please check regularly to stay informed.<br/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/privacypolicy/index.js